import React, { useEffect } from 'react';

// The real delivery app is the compiled Expo build served as static files at
// /app/index.html. The bare "/app" URL can fall through to this CRA SPA on some
// servers, so we immediately hand off to the real Expo app entry file.
const AppShell = () => {
  useEffect(() => {
    window.location.replace('/app/index.html');
  }, []);

  return (
    <div
      data-testid="app-redirect-loading"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f8fc',
        color: '#7851A9',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontSize: 16,
        fontWeight: 600,
      }}
    >
      Loading Spee&apos;V&apos;Dee…
    </div>
  );
};

export default AppShell;
